import axios from 'axios'
import { Component, FunctionalComponent } from 'preact'
import { capitalize } from '@insided/deprecated-preact-components/utils/string'
import Button from '@insided/control/uikit/Button'

/* eslint-disable import/no-internal-modules */
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import { Modal, ModalBody, ModalHeader } from '@insided/deprecated-preact-components/modal'
import UserAvatar from '@insided/deprecated-preact-components/User/UserAvatar'

export interface TopicCardTopic {
  title: string
  content: string
  featuredImage: string | null
  contentType: string
  author: {
    id: number
    username: string
    avatar: string
  }
  url: string,
  startDate?: number,
  type?: string
}

interface Props {
  isOpen: boolean
  onAdd: (topic: TopicCardTopic) => void
  onClose: () => void
}

interface State {
  topic: TopicCardTopic | null
  error: string | null
}

class AddTopicCardModal extends Component<Props, State> {
  urlInputRef: HTMLInputElement | null = null

  constructor(props: Props) {
    super(props)
    this.state = {
      topic: null,
      error: null
    }
  }

  componentDidMount = () => this.urlInputRef?.focus()

  onUrlInput = async (event: {target: HTMLInputElement}) => {
    const topicUrl = event.target.value

    try {
      const response = await axios.get(`/topic/checkurl?checkurl=${topicUrl}`)

      const { topictitle, content, featuredimage, contenttype, author, url, startDate, type } = response.data

      this.setState({
        topic: {
          title: topictitle,
          content,
          featuredImage: featuredimage,
          contentType: contenttype,
          author,
          url,
          startDate,
          type
        },
        error: null
      })
    } catch (e) {
      this.setState({ topic: null, error: "Sorry, there's no topic matching that URL" })
    }
  }

  onAdd = () => {
    const { topic } = this.state
    if (!topic) {
      return
    }
    this.props.onAdd(topic)
  }

  render() {
    const { isOpen, onClose } = this.props
    const { topic, error } = this.state
    return (
      <Modal isOpen={isOpen} size='medium'>
        <ModalHeader title='Topic card' onClose={() => onClose()} />
        <ModalBody>
          <div className='add-topic-card-modal'>
            <InputGroup
              ref={(ref: any) => {
                this.urlInputRef = ref?.base.querySelector('input') ?? null
              }}
              newStyle
              placeholder='Embed a community topic by pasting topic URL'
              onKeyUp={this.onUrlInput}
            />
            {error && <div className='no-results'>{error}</div>}
            {topic && <TopicResult topic={topic} onAdd={this.onAdd} />}
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

interface TopicResultProps {
  topic: TopicCardTopic
  onAdd: () => void
}

const TopicResult: FunctionalComponent<TopicResultProps> = ({ topic, onAdd }) => {
  const {
    title,
    contentType,
    author: { id, username, avatar }
  } = topic

  return (
    <div className='topic-result'>
      <div>
        <div className='title'>{title}</div>
        <div className='meta'>
          {capitalize(contentType)} by
          <UserAvatar
            disableLink
            style={{ width: '16px', height: '16px' }}
            user={{
              id: id,
              name: username,
              avatar
            }}
          />
          <span>{username}</span>
        </div>
      </div>
      <Button title='Add' onClick={() => onAdd()} />
    </div>
  )
}

export default AddTopicCardModal
